import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, FormControl, FormLabel, TextField, Radio, RadioGroup, Typography, Alert } from '@mui/material';
import { useCreateItemMutation } from '../store/docApi';
import { crafts, generateNumericId, getCosmosDate } from '../utils';

export default function ProjectCreate({ username }) {
  const [createItem, result] = useCreateItemMutation();
  const navigate = useNavigate();
  const params = useParams();

  const label = 'project';
  const pk = username ? username : '';
  const pattern_id = params.id ? params.id : '';
  const [id, setId] = useState(params.id ? `${params.id}-${generateNumericId(4)}` : generateNumericId(8));
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [craft, setCraft] = useState('knitting');

  async function handleSubmit(event) {
    event.preventDefault();
    const newProject = {
      label: label,
      id: id,
      name: name,
      craft: craft,
      pattern_id: pattern_id,
      connections: [{ _id: pattern_id, progress: {}, notes: [] }],
      startDate: getCosmosDate()
    };
    if (description.trim().length !== 0) newProject.description = description;
    await createItem({ label: label, pk: pk, data: newProject });
  }

  useEffect(() => {
    if (result && result.isSuccess) {
      navigate(`/projects/${result.data.pk}/${result.data.id}`);
    }
  }, [result, navigate]);

  return (
    <Box sx={styles.page}>
      {result && result.isError && <Alert severity="error">Error saving</Alert>}
      {result && result.isSuccess && <Alert severity="success">Saved successfully!</Alert>}
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Create {label}
        </Typography>
        <FormControl sx={{ mb: 2 }} fullWidth>
          <FormLabel>Id</FormLabel>
          <TextField name="id" value={id} onChange={(e) => setId(e.target.value)} size="small" />
        </FormControl>
        <FormControl sx={{ mb: 2 }} fullWidth>
          <FormLabel>Name</FormLabel>
          <TextField name="name" value={name} onChange={(e) => setName(e.target.value)} size="small" />
        </FormControl>
        <FormControl sx={{ mb: 2 }} fullWidth>
          <FormLabel>Description</FormLabel>
          <TextField
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
            size="small"
          />
        </FormControl>
        <FormControl sx={{ mb: 2 }} fullWidth>
          <FormLabel>Craft</FormLabel>
          <RadioGroup name="craft" value={craft} onChange={(e) => setCraft(e.target.value)} row>
            {crafts.map((craft, i) => (
              <FormControl key={i} component="fieldset">
                <Radio value={craft} />
                <Typography variant="body2">{craft}</Typography>
              </FormControl>
            ))}
          </RadioGroup>
        </FormControl>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
          <Button onClick={() => navigate(-1)} variant="outlined" color="secondary">
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  );
}

const styles = {
  page: {
    maxWidth: 400,
    margin: '0 auto',
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  }
};
